/* Fashion Corner theme JS — no dependencies */
(function () {
  'use strict';

  /* Branded page wait screen: keep it brief and always release the page. */
  const pageLoader = document.querySelector('[data-page-loader]');
  if (pageLoader) {
    let dismissed = false;
    let dismissTimer;
    const dismissLoader = () => {
      if (dismissed) return;
      dismissed = true;
      clearTimeout(dismissTimer);
      pageLoader.classList.add('is-hidden');
      window.setTimeout(() => pageLoader.remove(), 400);
    };
    const afterLoad = () => window.setTimeout(dismissLoader, 1450);
    if (document.readyState === 'complete') afterLoad();
    else window.addEventListener('load', afterLoad, { once: true });
    dismissTimer = window.setTimeout(dismissLoader, 2600);
    window.addEventListener('pageshow', event => {
      if (event.persisted) {
        dismissed = true;
        clearTimeout(dismissTimer);
        pageLoader.remove();
      }
    }, { once: true });
  }

  /* Mobile nav + search */
  const nav = document.getElementById('MobileNav');
  document.querySelectorAll('[data-menu-open]').forEach(b => b.addEventListener('click', () => { nav && nav.setAttribute('data-open', ''); document.body.style.overflow = 'hidden'; }));
  document.querySelectorAll('[data-menu-close]').forEach(b => b.addEventListener('click', () => { nav && nav.removeAttribute('data-open'); document.body.style.overflow = ''; }));
  const search = document.getElementById('SearchBar');
  document.querySelectorAll('[data-search-toggle]').forEach(b => b.addEventListener('click', () => {
    if (!search) return;
    const open = search.hasAttribute('data-open');
    if (open) search.removeAttribute('data-open'); else { search.setAttribute('data-open', ''); search.querySelector('input')?.focus(); }
  }));

  /* AJAX cart drawer */
  const cartDrawer = document.getElementById('CartDrawer');
  const cartOverlay = document.querySelector('[data-cart-overlay]');
  const cartItems = document.querySelector('[data-cart-items]');
  const cartEmpty = document.querySelector('[data-cart-empty]');
  const cartFooter = document.querySelector('[data-cart-footer]');
  const cartRoot = window.Shopify?.routes?.root || '/';
  const storeCurrency = window.Shopify?.currency?.active || 'INR';

  function formatStoreMoney(cents) {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: storeCurrency }).format(cents / 100); }
    catch (_) { return (cents / 100).toFixed(2); }
  }

  async function renderCartDrawer() {
    if (!cartDrawer || !cartItems) return null;
    const response = await fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Could not load your cart');
    const cart = await response.json();
    cartItems.replaceChildren();
    document.querySelectorAll('[data-cart-count]').forEach(count => { count.textContent = cart.item_count; });
    cartEmpty.hidden = cart.items.length > 0;
    cartFooter.hidden = cart.items.length === 0;
    document.querySelector('[data-cart-subtotal]').textContent = formatStoreMoney(cart.items_subtotal_price);

    cart.items.forEach(item => {
      const row = document.createElement('article');
      row.className = 'cart-drawer__item';
      const imageLink = document.createElement('a');
      imageLink.href = item.url;
      if (item.featured_image) {
        const image = document.createElement('img');
        image.src = item.featured_image;
        image.alt = '';
        image.loading = 'lazy';
        imageLink.append(image);
      }
      const details = document.createElement('div');
      details.className = 'cart-drawer__details';
      const title = document.createElement('a');
      title.href = item.url;
      title.textContent = item.product_title;
      const variant = document.createElement('span');
      variant.textContent = item.variant_title === 'Default Title' ? '' : item.variant_title;
      const price = document.createElement('strong');
      price.textContent = formatStoreMoney(item.final_line_price);
      details.append(title, variant, price);
      const controls = document.createElement('div');
      controls.className = 'cart-drawer__controls';
      const minus = document.createElement('button');
      minus.type = 'button'; minus.dataset.cartChange = '-1'; minus.dataset.cartKey = item.key; minus.setAttribute('aria-label', 'Decrease quantity'); minus.textContent = '−';
      const quantity = document.createElement('span'); quantity.textContent = item.quantity;
      const plus = document.createElement('button');
      plus.type = 'button'; plus.dataset.cartChange = '1'; plus.dataset.cartKey = item.key; plus.setAttribute('aria-label', 'Increase quantity'); plus.textContent = '+';
      const remove = document.createElement('button');
      remove.type = 'button'; remove.className = 'cart-drawer__remove'; remove.dataset.cartRemove = item.key; remove.textContent = 'Remove';
      controls.append(minus, quantity, plus, remove);
      row.append(imageLink, details, controls);
      cartItems.append(row);
    });
    return cart;
  }

  function openCartDrawer() {
    if (!cartDrawer || !cartOverlay) return;
    if (typeof closeWishlist === 'function') closeWishlist();
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.setAttribute('data-open', '');
    cartOverlay.hidden = false;
    cartOverlay.setAttribute('data-open', '');
    document.body.setAttribute('data-cart-open', '');
    cartDrawer.querySelector('[data-cart-close]')?.focus();
  }

  function closeCartDrawer() {
    if (!cartDrawer || !cartOverlay) return;
    cartDrawer.removeAttribute('data-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.removeAttribute('data-open');
    cartOverlay.hidden = true;
    document.body.removeAttribute('data-cart-open');
  }

  async function addCartData(data, errorTarget) {
    const response = await fetch(cartRoot + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
    if (!response.ok) {
      const error = await response.json().catch(() => ({}));
      throw new Error(error.description || 'Could not add this item');
    }
    if (errorTarget) { errorTarget.hidden = true; errorTarget.textContent = ''; }
    await renderCartDrawer();
    openCartDrawer();
  }

  document.addEventListener('click', async event => {
    if (event.target.closest('[data-cart-open]')) {
      event.preventDefault();
      try { await renderCartDrawer(); openCartDrawer(); } catch (_) { window.location.href = cartRoot + 'cart'; }
      return;
    }
    if (event.target.closest('[data-cart-close]') || event.target === cartOverlay) { closeCartDrawer(); return; }
    const quantityChange = event.target.closest('[data-cart-change], [data-cart-remove]');
    if (quantityChange) {
      const key = quantityChange.dataset.cartKey || quantityChange.dataset.cartRemove;
      const current = quantityChange.dataset.cartChange ? Number(quantityChange.dataset.cartChange) : 0;
      const row = quantityChange.closest('.cart-drawer__item');
      const quantity = Number(row?.querySelector('.cart-drawer__controls > span')?.textContent || 1);
      try {
        await fetch(cartRoot + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: quantityChange.hasAttribute('data-cart-remove') ? 0 : Math.max(0, quantity + current) }) });
        await renderCartDrawer();
      } catch (_) { /* Keep the current drawer contents if the request fails. */ }
    }
  });
  document.addEventListener('keydown', event => { if (event.key === 'Escape' && cartDrawer?.hasAttribute('data-open')) closeCartDrawer(); });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-card__form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-quick-add-error]');
    button.disabled = true;
    try { await addCartData(new FormData(form), error); }
    catch (err) { if (error) { error.textContent = err.message; error.hidden = false; } }
    finally { button.disabled = false; }
  });

  /* Quick view modal */
  const quickViewDialog = document.querySelector('[data-quick-view-dialog]');
  const quickViewContent = document.querySelector('[data-quick-view-content]');
  let quickViewProduct = null;
  let quickViewVariant = null;
  function quickViewPrice(cents) { return formatStoreMoney(cents); }

  document.addEventListener('click', async event => {
    const trigger = event.target.closest('[data-quick-view]');
    if (trigger && quickViewDialog && quickViewContent) {
      quickViewProduct = null;
      quickViewVariant = null;
      quickViewContent.replaceChildren();
      const loading = document.createElement('p'); loading.className = 'quick-view__loading'; loading.textContent = 'Loading product…';
      quickViewContent.append(loading);
      quickViewDialog.showModal();
      try {
        const response = await fetch(cartRoot + 'products/' + encodeURIComponent(trigger.dataset.quickView) + '.js');
        if (!response.ok) throw new Error('Product unavailable');
        quickViewProduct = await response.json();
        renderQuickView(quickViewProduct);
      } catch (_) {
        quickViewContent.textContent = 'Sorry, this product could not be loaded.';
      }
      return;
    }
    if (event.target.closest('[data-quick-view-close]') && quickViewDialog?.open) quickViewDialog.close();

    const zoomTrigger = event.target.closest('[data-zoom-trigger]');
    if (zoomTrigger) {
      const activeImage = zoomTrigger.closest('.product__main-media')?.querySelector('[data-active] img');
      const zoomDialog = document.querySelector('[data-zoom-dialog]');
      const zoomImage = zoomDialog?.querySelector('[data-zoom-image]');
      if (activeImage && zoomDialog && zoomImage) { zoomImage.src = activeImage.currentSrc || activeImage.src; zoomImage.alt = activeImage.alt; zoomDialog.showModal(); }
    }
    if (event.target.closest('[data-zoom-close]')) document.querySelector('[data-zoom-dialog]')?.close();

    if (event.target.closest('[data-quick-view-add]') && quickViewProduct && quickViewVariant) {
      const button = event.target.closest('[data-quick-view-add]');
      button.disabled = true;
      const formData = new FormData();
      formData.set('id', quickViewVariant.id);
      formData.set('quantity', '1');
      try { await addCartData(formData, quickViewContent.querySelector('[data-quick-view-error]')); quickViewDialog.close(); }
      catch (err) { const error = quickViewContent.querySelector('[data-quick-view-error]'); error.textContent = err.message; error.hidden = false; button.disabled = false; }
    }

    if (event.target.closest('[data-sticky-cart-add]')) {
      const product = event.target.closest('[data-product-form]');
      const addButton = product?.querySelector('[data-add-to-cart]');
      if (addButton && !addButton.disabled) addButton.click();
    }
    if (event.target.closest('[data-back-to-top]')) window.scrollTo({ top: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
  });

  function renderQuickView(product) {
    quickViewContent.replaceChildren();
    const media = document.createElement('div'); media.className = 'quick-view__media';
    if (product.featured_image) { const image = document.createElement('img'); image.src = product.featured_image; image.alt = product.title; image.loading = 'eager'; media.append(image); }
    const details = document.createElement('div'); details.className = 'quick-view__details';
    const title = document.createElement('h2'); title.id = 'QuickViewTitle'; title.textContent = product.title;
    const price = document.createElement('p'); price.className = 'quick-view__price'; price.dataset.quickViewPrice = '';
    const options = document.createElement('div'); options.className = 'quick-view__options';
    (product.options || []).forEach((name, index) => {
      if (name === 'Title' && product.variants.length === 1) return;
      const label = document.createElement('label'); label.textContent = name;
      const select = document.createElement('select'); select.dataset.quickOption = String(index); select.setAttribute('aria-label', name);
      [...new Set(product.variants.map(variant => variant.options[index]))].forEach(value => { const option = document.createElement('option'); option.value = value; option.textContent = value; select.append(option); });
      label.append(select); options.append(label);
    });
    const error = document.createElement('p'); error.className = 'quick-view__error'; error.dataset.quickViewError = ''; error.hidden = true;
    const add = document.createElement('button'); add.type = 'button'; add.className = 'btn btn--yellow btn--full'; add.dataset.quickViewAdd = ''; add.textContent = 'Add to cart';
    const link = document.createElement('a'); link.className = 'quick-view__product-link'; link.href = cartRoot + 'products/' + encodeURIComponent(product.handle); link.textContent = 'View full details';
    details.append(title, price, options, error, add, link);
    quickViewContent.append(media, details);
    const selectors = [...quickViewContent.querySelectorAll('[data-quick-option]')];
    quickViewVariant = product.variants.find(variant => variant.available) || product.variants[0];
    if (quickViewVariant) selectors.forEach((select, index) => { select.value = quickViewVariant.options[index]; });
    updateQuickViewVariant();
  }

  function updateQuickViewVariant() {
    if (!quickViewProduct || !quickViewContent) return;
    const selectors = [...quickViewContent.querySelectorAll('[data-quick-option]')];
    const selected = selectors.length ? selectors.map(select => select.value) : (quickViewProduct.variants.find(variant => variant.available) || quickViewProduct.variants[0])?.options || [];
    quickViewVariant = quickViewProduct.variants.find(variant => variant.options.every((value, index) => value === selected[index])) || null;
    const price = quickViewContent.querySelector('[data-quick-view-price]');
    const add = quickViewContent.querySelector('[data-quick-view-add]');
    if (quickViewVariant) { price.textContent = quickViewPrice(quickViewVariant.price); add.disabled = !quickViewVariant.available; }
    else { price.textContent = ''; add.disabled = true; }
  }
  quickViewDialog?.addEventListener('change', event => { if (event.target.matches('[data-quick-option]')) updateQuickViewVariant(); });
  document.querySelector('[data-zoom-dialog]')?.addEventListener('click', event => { if (event.target === event.currentTarget) event.currentTarget.close(); });
  quickViewDialog?.addEventListener('click', event => { if (event.target === event.currentTarget) quickViewDialog.close(); });

  /* Back-to-top control */
  const backToTop = document.querySelector('[data-back-to-top]');
  const syncBackToTop = () => backToTop?.toggleAttribute('data-visible', window.scrollY > 500);
  window.addEventListener('scroll', syncBackToTop, { passive: true });
  syncBackToTop();

  /* Quantity steppers */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-qty-change]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    const min = parseInt(input.min || '1', 10);
    let v = parseInt(input.value || '1', 10) + parseInt(btn.dataset.qtyChange, 10);
    if (v < min) v = min;
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* Product: variant picker + gallery */
  document.querySelectorAll('[data-product-form]').forEach(section => {
    const dataEl = section.querySelector('[data-variants-json]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const idInput = section.querySelector('input[name="id"]');
    const addBtn = section.querySelector('[data-add-to-cart]');
    const addText = addBtn ? addBtn.querySelector('[data-add-text]') : null;
    const priceEl = section.querySelector('[data-price]');
    const stockStatus = section.querySelector('[data-stock-status]');
    const stockDataEl = section.querySelector('[data-stock-json]');
    const stockById = new Map(stockDataEl ? JSON.parse(stockDataEl.textContent).map(item => [String(item.id), item]) : []);
    const stockThreshold = parseInt(section.dataset.lowStockThreshold || '5', 10);
    const stickyCart = section.querySelector('[data-sticky-cart]');
    const stickyPrice = section.querySelector('[data-sticky-price]');
    const moneyFormat = section.dataset.moneyFormat || '{{amount}}';

    function money(cents) {
      const v = (cents / 100).toFixed(2);
      const [int, dec] = v.split('.');
      const withCommas = int.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return moneyFormat.replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + dec)
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, int.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + dec);
    }

    let syncStickyCart = () => {};

    function selectedOptions() {
      return Array.from(section.querySelectorAll('[data-option-index]')).map(group => {
        const checked = group.querySelector('input:checked');
        const select = group.querySelector('select');
        return checked ? checked.value : (select ? select.value : null);
      });
    }

    function update() {
      const opts = selectedOptions();
      const variant = variants.find(v => v.options.every((o, i) => o === opts[i]));
      section.querySelectorAll('[data-option-index]').forEach(group => {
        const idx = parseInt(group.dataset.optionIndex, 10);
        const label = group.querySelector('[data-option-value]');
        if (label) label.textContent = opts[idx] || '';
        group.querySelectorAll('input').forEach(input => {
          const test = opts.slice(); test[idx] = input.value;
          const match = variants.find(v => v.options.every((o, i) => i === idx ? o === test[i] : o === opts[i]));
          const lab = group.querySelector('label[for="' + input.id + '"]');
          if (lab) lab.classList.toggle('is-unavailable', !match || !match.available);
        });
      });
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; if (addText) addText.textContent = addBtn.dataset.textUnavailable; }
        if (stockStatus) stockStatus.hidden = true;
        syncStickyCart();
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (addBtn) {
        addBtn.disabled = !variant.available;
        if (addText) addText.textContent = variant.available ? addBtn.dataset.textAdd : addBtn.dataset.textSoldOut;
      }
      if (priceEl) {
        let html = '<span class="price__current">' + money(variant.price) + '</span>';
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          html += '<s class="price__compare">' + money(variant.compare_at_price) + '</s><span class="price__pct">-' + pct + '%</span>';
        }
        priceEl.innerHTML = html;
        priceEl.classList.toggle('price--sale', !!(variant.compare_at_price && variant.compare_at_price > variant.price));
      }
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      if (stockStatus) {
        const stock = stockById.get(String(variant.id));
        const low = stock?.tracked && stock.quantity > 0 && stock.quantity <= stockThreshold;
        stockStatus.hidden = !low;
        stockStatus.textContent = low ? stockStatus.dataset.stockText.replace('COUNT', stock.quantity) : '';
      }
      if (variant.featured_media) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href); url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
      syncStickyCart();
    }

    function showMedia(id) {
      section.querySelectorAll('[data-media-id]').forEach(m => m.toggleAttribute('data-active', String(m.dataset.mediaId) === String(id)));
      section.querySelectorAll('[data-thumb-id]').forEach(t => { if (String(t.dataset.thumbId) === String(id)) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current'); });
    }

    section.querySelectorAll('[data-option-index] input, [data-option-index] select').forEach(el => el.addEventListener('change', update));
    section.querySelectorAll('[data-thumb-id]').forEach(t => t.addEventListener('click', () => showMedia(t.dataset.thumbId)));

    if (stickyCart && addBtn) {
      syncStickyCart = () => {
        const rect = addBtn.getBoundingClientRect();
        const inView = rect.top < window.innerHeight && rect.bottom > 0;
        stickyCart.hidden = addBtn.disabled || inView || window.scrollY < 250;
        stickyCart.setAttribute('aria-hidden', String(stickyCart.hidden));
      };
      window.addEventListener('scroll', syncStickyCart, { passive: true });
      window.addEventListener('resize', syncStickyCart);
      syncStickyCart();
    }

    /* AJAX add to cart */
    const form = section.querySelector('form[action*="/cart/add"]');
    if (form && addBtn) {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        addBtn.disabled = true; if (addText) addText.textContent = addBtn.dataset.textAdding;
        try {
          const res = await fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } });
          if (!res.ok) throw new Error((await res.json()).description || 'Error');
          const cart = await (await fetch(window.Shopify.routes.root + 'cart.js')).json();
          document.querySelectorAll('[data-cart-count]').forEach(c => c.textContent = cart.item_count);
          await renderCartDrawer();
          openCartDrawer();
          if (addText) addText.textContent = addBtn.dataset.textAdded;
          setTimeout(() => { if (addText) addText.textContent = addBtn.dataset.textAdd; addBtn.disabled = false; }, 1600);
        } catch (err) {
          const errEl = section.querySelector('[data-form-error]');
          if (errEl) { errEl.textContent = err.message; errEl.hidden = false; }
          if (addText) addText.textContent = addBtn.dataset.textAdd; addBtn.disabled = false;
        }
      });
    }

    /* PIN code check (client-side, serviceable prefixes from section settings) */
    const pinForm = section.querySelector('[data-pincode]');
    if (pinForm) {
      const pinInput = pinForm.querySelector('input');
      const out = pinForm.parentElement.querySelector('[data-pincode-result]');
      const clearPinResult = () => {
        out.textContent = '';
        out.style.color = '';
      };
      pinInput.addEventListener('input', clearPinResult);
      pinForm.addEventListener('submit', e => {
        e.preventDefault();
        const pin = pinInput.value.trim();
        const country = (pinForm.dataset.countryCode || 'IN').toUpperCase();
        const postal = pin.toUpperCase();
        let valid = false;
        if (country === 'IN') valid = /^[1-9]\d{5}$/.test(postal);
        else if (country === 'US') valid = /^\d{5}(-\d{4})?$/.test(postal);
        else if (country === 'CA') valid = /^[A-Z]\d[A-Z][ -]?\d[A-Z]\d$/.test(postal);
        else if (country === 'GB') valid = /^(GIR 0AA|[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2})$/.test(postal);
        else valid = pin.length >= 3 && pin.length <= 10 && /^[\p{L}\p{N}](?:[\p{L}\p{N} -]*[\p{L}\p{N}])?$/u.test(postal);
        if (!valid) { out.textContent = pinForm.dataset.textInvalid; out.style.color = 'var(--fc-sale)'; return; }
        const excluded = (pinForm.dataset.excluded || '').split(',').map(s => s.trim()).filter(Boolean);
        const blocked = country === 'IN' && excluded.some(p => pin.startsWith(p));
        out.textContent = blocked ? pinForm.dataset.textNo : pinForm.dataset.textYes;
        out.style.color = blocked ? 'var(--fc-sale)' : 'var(--fc-success)';
      });
    }
  });

  /* Cart page: quantity change + remove via AJAX */
  const cartPage = document.querySelector('[data-cart-page]');
  if (cartPage) {
    async function change(line, quantity) {
      const res = await fetch(window.Shopify.routes.root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line, quantity }) });
      if (res.ok) window.location.reload();
    }
    cartPage.querySelectorAll('[data-line-qty]').forEach(input => input.addEventListener('change', () => change(parseInt(input.dataset.lineQty, 10), parseInt(input.value, 10))));
    cartPage.querySelectorAll('[data-line-remove]').forEach(btn => btn.addEventListener('click', e => { e.preventDefault(); change(parseInt(btn.dataset.lineRemove, 10), 0); }));
  }

  /* Collection sort */
  document.querySelectorAll('[data-sort-by]').forEach(sel => sel.addEventListener('change', () => {
    const url = new URL(window.location.href); url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page'); window.location.href = url.toString();
  }));
  document.querySelectorAll('[data-facet-form]').forEach(form => form.addEventListener('change', () => form.submit()));

  /* Addresses */
  document.querySelectorAll('[data-address-toggle]').forEach(b => b.addEventListener('click', () => {
    const t = document.getElementById(b.dataset.addressToggle); if (t) t.toggleAttribute('data-open');
  }));
  document.querySelectorAll('[data-address-delete]').forEach(b => b.addEventListener('click', e => {
    e.preventDefault();
    if (!confirm(b.dataset.confirm || 'Delete this address?')) return;
    const f = document.createElement('form'); f.method = 'post'; f.action = b.dataset.target;
    f.innerHTML = '<input type="hidden" name="_method" value="delete">'; document.body.appendChild(f); f.submit();
  }));

  /* Wishlist: saved in this browser and shared across theme pages. */
  const wishlistKey = 'fashion-corner-wishlist';
  const wishlistDrawer = document.getElementById('WishlistDrawer');
  const wishlistOverlay = document.querySelector('[data-wishlist-overlay]');
  const wishlistItems = document.querySelector('[data-wishlist-items]');
  const wishlistEmpty = document.querySelector('[data-wishlist-empty]');

  function getWishlist() {
    try {
      const saved = JSON.parse(localStorage.getItem(wishlistKey) || '[]');
      return Array.isArray(saved) ? saved.filter(handle => typeof handle === 'string') : [];
    } catch (_) { return []; }
  }

  function syncWishlistButtons() {
    const saved = getWishlist();
    document.querySelectorAll('[data-wishlist-count]').forEach(count => { count.textContent = saved.length; });
    document.querySelectorAll('[data-wishlist-toggle]').forEach(button => {
      const isSaved = saved.includes(button.dataset.productHandle);
      button.setAttribute('aria-pressed', String(isSaved));
      button.setAttribute('aria-label', (isSaved ? 'Remove ' : 'Add ') + (button.dataset.productTitle || button.getAttribute('aria-label') || 'product') + (isSaved ? ' from wishlist' : ' to wishlist'));
    });
  }

  async function renderWishlist() {
    if (!wishlistItems || !wishlistEmpty) return;
    const handles = getWishlist();
    wishlistItems.replaceChildren();
    wishlistEmpty.hidden = handles.length > 0;
    const root = window.Shopify?.routes?.root || '/';

    for (const handle of handles) {
      let product;
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js');
        if (!response.ok) throw new Error('Product unavailable');
        product = await response.json();
      } catch (_) {
        product = { title: handle.replace(/-/g, ' '), handle, featured_image: null };
      }

      const row = document.createElement('article');
      row.className = 'wishlist-drawer__item';
      const link = document.createElement('a');
      link.href = root + 'products/' + encodeURIComponent(handle);
      if (product.featured_image) {
        const image = document.createElement('img');
        image.src = product.featured_image;
        image.alt = '';
        image.loading = 'lazy';
        link.append(image);
      }
      const title = document.createElement('span');
      title.textContent = product.title;
      link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'wishlist-drawer__remove';
      remove.dataset.wishlistRemove = handle;
      remove.setAttribute('aria-label', 'Remove ' + product.title + ' from wishlist');
      remove.textContent = '×';
      row.append(link, remove);
      wishlistItems.append(row);
    }
    syncWishlistButtons();
  }

  function closeWishlist() {
    if (!wishlistDrawer || !wishlistOverlay) return;
    wishlistDrawer.removeAttribute('data-open');
    wishlistDrawer.setAttribute('aria-hidden', 'true');
    wishlistOverlay.removeAttribute('data-open');
    wishlistOverlay.hidden = true;
    document.body.removeAttribute('data-wishlist-open');
  }

  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      const handle = toggle.dataset.productHandle;
      const saved = getWishlist();
      const next = saved.includes(handle) ? saved.filter(item => item !== handle) : [handle, ...saved];
      try { localStorage.setItem(wishlistKey, JSON.stringify(next)); } catch (_) { /* Storage may be disabled by the browser. */ }
      syncWishlistButtons();
      renderWishlist();
      return;
    }

    if (event.target.closest('[data-wishlist-open]') && wishlistDrawer && wishlistOverlay) {
      closeCartDrawer();
      wishlistDrawer.setAttribute('data-open', '');
      wishlistDrawer.setAttribute('aria-hidden', 'false');
      wishlistOverlay.hidden = false;
      wishlistOverlay.setAttribute('data-open', '');
      document.body.setAttribute('data-wishlist-open', '');
      renderWishlist();
      wishlistDrawer.querySelector('[data-wishlist-close]')?.focus();
      return;
    }

    if (event.target.closest('[data-wishlist-close]') || event.target === wishlistOverlay) {
      closeWishlist();
      document.querySelector('[data-wishlist-open]')?.focus();
      return;
    }

    const remove = event.target.closest('[data-wishlist-remove]');
    if (remove) {
      const next = getWishlist().filter(handle => handle !== remove.dataset.wishlistRemove);
      try { localStorage.setItem(wishlistKey, JSON.stringify(next)); } catch (_) { /* Storage may be disabled by the browser. */ }
      renderWishlist();
    }
  });

  document.addEventListener('keydown', event => {
    if (event.key === 'Escape' && wishlistDrawer?.hasAttribute('data-open')) {
      closeWishlist();
      document.querySelector('[data-wishlist-open]')?.focus();
    }
  });
  window.addEventListener('storage', event => { if (event.key === wishlistKey) { syncWishlistButtons(); renderWishlist(); } });
  syncWishlistButtons();

  /* Recently viewed products, remembered in this browser. */
  const recentlyViewedKey = 'fashion-corner-recently-viewed';
  function getRecentlyViewed() {
    try {
      const saved = JSON.parse(localStorage.getItem(recentlyViewedKey) || '[]');
      return Array.isArray(saved) ? saved.filter(handle => typeof handle === 'string') : [];
    } catch (_) { return []; }
  }

  const currentProduct = document.querySelector('[data-product-view-handle]')?.dataset.productViewHandle;
  if (currentProduct) {
    const viewed = [currentProduct, ...getRecentlyViewed().filter(handle => handle !== currentProduct)].slice(0, 12);
    try { localStorage.setItem(recentlyViewedKey, JSON.stringify(viewed)); } catch (_) { /* Storage may be disabled by the browser. */ }
  }

  document.querySelectorAll('[data-recently-viewed]').forEach(async section => {
    const list = section.querySelector('[data-recently-viewed-items]');
    if (!list) return;
    const limit = parseInt(section.dataset.limit || '4', 10);
    const root = window.Shopify?.routes?.root || '/';
    const handles = getRecentlyViewed().filter(handle => handle !== currentProduct).slice(0, limit);
    const products = await Promise.all(handles.map(async handle => {
      try {
        const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js');
        return response.ok ? await response.json() : null;
      } catch (_) { return null; }
    }));

    products.filter(Boolean).forEach(product => {
      const link = document.createElement('a');
      link.className = 'recently-viewed__card';
      link.href = root + 'products/' + encodeURIComponent(product.handle);
      const media = document.createElement('div');
      media.className = 'recently-viewed__media';
      if (product.featured_image) {
        const image = document.createElement('img');
        image.src = product.featured_image;
        image.alt = '';
        image.loading = 'lazy';
        media.append(image);
      }
      const title = document.createElement('span');
      title.className = 'recently-viewed__title';
      title.textContent = product.title;
      link.append(media, title);
      list.append(link);
    });
    if (list.childElementCount) section.hidden = false;
  });

  /* Instagram reels carousel. */
  function initInstagramReels(section) {
    if (section.dataset.reelsInitialized) return;
    const viewport = section.querySelector('[data-reels-viewport]');
    const track = section.querySelector('[data-reels-track]');
    const slides = [...section.querySelectorAll('[data-reel-slide]')];
    const previous = section.querySelector('[data-reels-previous]');
    const next = section.querySelector('[data-reels-next]');
    if (!viewport || !track || !slides.length) return;
    section.dataset.reelsInitialized = 'true';
    let activeIndex = Math.floor(slides.length / 2);
    let pointerStart = null;

    function centerActiveSlide() {
      const slide = slides[activeIndex];
      if (!slide) return;
      const offset = viewport.clientWidth / 2 - (slide.offsetLeft + slide.offsetWidth / 2);
      track.style.transform = `translate3d(${offset}px, 0, 0)`;
      slides.forEach((item, index) => item.classList.toggle('is-active', index === activeIndex));
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
      slides.forEach((item, index) => {
        const video = item.querySelector('[data-reel-video]');
        const playButton = item.querySelector('[data-reel-play]');
        if (!video) return;
        if (index === activeIndex) {
          video.muted = true;
          video.play().then(() => playButton?.setAttribute('data-playing', 'true')).catch(() => playButton?.setAttribute('data-playing', 'false'));
        } else {
          video.pause();
          video.muted = true;
          playButton?.setAttribute('data-playing', 'false');
          item.querySelector('[data-reel-mute]')?.setAttribute('data-muted', 'true');
        }
      });
    }

    function goTo(index) {
      activeIndex = Math.max(0, Math.min(slides.length - 1, index));
      centerActiveSlide();
    }

    previous?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));
    viewport.addEventListener('keydown', event => {
      if (event.key === 'ArrowLeft') { event.preventDefault(); goTo(activeIndex - 1); }
      if (event.key === 'ArrowRight') { event.preventDefault(); goTo(activeIndex + 1); }
    });
    viewport.addEventListener('pointerdown', event => {
      if (event.pointerType === 'mouse' || event.target.closest('button, a')) return;
      pointerStart = event.clientX;
    });
    viewport.addEventListener('pointerup', event => {
      if (pointerStart === null) return;
      const distance = event.clientX - pointerStart;
      pointerStart = null;
      if (Math.abs(distance) > 45) goTo(activeIndex + (distance < 0 ? 1 : -1));
    });
    viewport.addEventListener('pointercancel', () => { pointerStart = null; });
    section.addEventListener('click', event => {
      const playButton = event.target.closest('[data-reel-play]');
      const muteButton = event.target.closest('[data-reel-mute]');
      if (playButton) {
        const video = playButton.closest('[data-reel-slide]')?.querySelector('[data-reel-video]');
        if (!video) return;
        if (video.paused) video.play().then(() => playButton.setAttribute('data-playing', 'true')).catch(() => {});
        else { video.pause(); playButton.setAttribute('data-playing', 'false'); }
      }
      if (muteButton) {
        const video = muteButton.closest('[data-reel-slide]')?.querySelector('[data-reel-video]');
        if (!video) return;
        video.muted = !video.muted;
        muteButton.setAttribute('data-muted', String(video.muted));
        muteButton.setAttribute('aria-label', video.muted ? 'Unmute reel' : 'Mute reel');
      }
    });
    window.addEventListener('resize', centerActiveSlide, { passive: true });
    centerActiveSlide();
  }

  document.querySelectorAll('[data-instagram-reels]').forEach(initInstagramReels);
  document.addEventListener('shopify:section:load', event => {
    const section = event.target.querySelector('[data-instagram-reels]');
    if (section) initInstagramReels(section);
  });
})();
